import {mapActions} from 'pinia';
import {useLayoutStore} from '@store';

export default {
    data: () => ({
        headerBreadcrumbs: [],
    }),
    methods: {
        ...mapActions(useLayoutStore, {
            setHeaderBreadcrumbs: 'setHeaderBreadcrumbs',
            clearHeaderBreadcrumbs: 'clearHeaderBreadcrumbs',
        }),
    },
    watch: {
        headerBreadcrumbs: {
            immediate: true,
            handler() {
                this.setHeaderBreadcrumbs(this.headerBreadcrumbs);
            },
        },
    },
    beforeDestroy() {
        this.clearHeaderBreadcrumbs();
    },
};
